import { Redirect, Stack } from 'expo-router';

import { useLoyaltyContext } from 'state/loyalty';
import { LoyaltyClaimPointsProvider } from 'state/loyalty-claim-points';
import { primitive } from 'styles/constants';
import { routes } from 'utils/routing';

export default function ClaimPointsLayout() {
  const { claimPointsEnabled } = useLoyaltyContext();
  if (!claimPointsEnabled) {
    return <Redirect href={routes.base} />;
  }

  return (
    <LoyaltyClaimPointsProvider>
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: primitive.$mayoEggWhite },
        }}
      />
    </LoyaltyClaimPointsProvider>
  );
}
